import { createGlobalStyle } from 'styled-components';

export const ScheduleCalendarStyle = createGlobalStyle`
  .fc .fc-toolbar.fc-header-toolbar{margin-bottom:0;}      
  .fc .fc-button-primary{background-color:transparent;border:solid 1px transparent;border-radius:20px;}
  .fc .fc-button-primary:hover,.fc .fc-button-primary:not(:disabled):active{background-color:transparent;border:solid 1px transparent;border-radius:20px;}
  .fc-icon-chevron-left::before,.fc-icon-chevron-right::before{color:#0083c1;}
  .fc .fc-cell-shaded, .fc .fc-day-disabled{background-color:#fff;}
  .fc .fc-daygrid-event{padding:0;margin-bottom:3px;}
  .fc-daygrid-day-number{font-weight:500;color:#666;font-size:15px;}
  .fc .fc-toolbar-title{font-size:16px;padding-left:10px;margin-top:0px;}
  .fc-day-today {background-color:#eee!important;border-top:3px solid #cc0033!important;}
  .fc-day-today .fc-daygrid-day-number {color:#cc0033!important;}
`;